import { __ } from './utils';
import { Selector, SelectorOptionsList } from './shared/index';

export default ({ value = null, options = [], onChange = null }) => {	
	return (
		<Selector id="box-type-selector" title={  __('Type de box') }>
			<SelectorOptionsList value={ value } options={ options } onChange={ onChange } />
		</Selector>
	)
};